import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoItModalComponent } from './do-it-modal.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule
  ],
  declarations: [DoItModalComponent],
  entryComponents: [DoItModalComponent]
})
export class DoItModalModule { }
